
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ReferralInfo } from "@/components/registration/ReferralInfo";
import { RegistrationForm } from "@/components/registration/RegistrationForm";
import { useReferral } from "@/hooks/useReferral";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from "react-i18next";

const Register = () => {
  const { referralCode, hasStoredReferral, processReferralToken } = useReferral();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation(['auth', 'common']);

  // Redirect if already logged in
  useEffect(() => {
    if (!loading && user) {
      console.log('Register - User already authenticated, redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  // Show loading while checking auth status
  if (loading) {
    return (
      <div className="min-h-screen bg-uplivion-lightBlue/30 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-uplivion-blue"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-uplivion-lightBlue/30 flex flex-col items-center justify-center p-4">
      <a href="https://www.uplivion.life" className="mb-8">
        <img 
          src="/uplivion-logo.svg" 
          alt="uplivion" 
          className="h-10 w-auto"
        />
      </a>
      
      <ReferralInfo hasReferral={hasStoredReferral} />
      
      <RegistrationForm referralCode={referralCode} processReferralToken={processReferralToken} />
      
      <div className="mt-6 text-center">
        <p className="text-sm text-gray-600">
          {t('register.hasAccount')} {" "}
          <Link 
            to="/login" 
            className="text-uplivion-blue hover:underline font-medium"
          >
            {t('register.loginLink')}
          </Link>
        </p>
      </div>
      
      <div className="mt-4">
        <Button variant="outline" asChild>
          <a href="https://www.uplivion.life">
            {t('common:buttons.backToWebsite')}
          </a>
        </Button>
      </div>
    </div>
  );
};

export default Register;
